<template>
    <li class="node-tree">
        <router-link :class="'label cate_name'" :to="{name: SiteConstants.PG020, params: {pageNo: 2,categoryCd : node[value]}}" v-if="node[value] != undefined && node[value] != null" @click.native="reload">
            <template v-if="node['CATEGORY_URL']">
                <span class="menu-icon01">
                    <img :src="node['CATEGORY_URL']" width="32" height="32" align="middle" class="img-mp" @error="getErrImage"/>
                </span>
                <span>{{node[label]}}</span>
            </template>
            <template v-else>
                <span class="menu-icon01" style="visibility: hidden;">
                    <img :src="node['CATEGORY_URL']" width="32" height="32" align="middle" class="img-mp" @error="getErrImage"/>
                </span>
                <span class="tree_label">{{node[label]}}</span>
            </template>
        </router-link>
        <ul v-if="node[children] && node[children].length" v-show="open">
            <node v-for="(child, index) in node[children]" :key="index" :node="child" :children="children" :label="label" :value="value" @selectNode="selectLink"></node>
        </ul>
    </li>
</template>

<script>
import common from "assets/js/common";
import SiteConstants from 'assets/const/SiteConstants.json';
/* 
* Import libs and componnents
*/
export default {
    /* 
    * Name of component
    */
    name: "node",
    /* 
    * Declare props
    */
    props: {
        node: {
            type: [Array,Object]
        },
        children: {
            type: String
        },
        label: {
            type: String
        },
        value: {
            type: String
        },
        marginLeft:{
            type: String
        }
    },
    /* 
    * Declare data
    */
    data() {
        return {
            open: false,
            SiteConstants: SiteConstants,
        }
    },
    mounted() {
        if(this.marginLeft != undefined){
            this.$el.style.setProperty('--margin-left-ul', this.marginLeft);
        }
        var _this = this;
        var categoryCd = "";
        var queryData = _this.$route.query;
        var params = _this.$route.params;
        if(Object.keys(queryData).length > 0){
            categoryCd = queryData.categoryCd;
        }
        if(Object.keys(params).length > 0){
            categoryCd = params.categoryCd;
        }

        this.recursiveToOpen(_this.node, categoryCd);
    },
    methods: {
        /* 
        * Function selectLink 
        */
        selectLink: function(CATEGORY_CD) {
            //set tranferdata into params of router
            var _this = this;
            var categoryCd = "";
            var queryData = _this.$route.query;
            var params = _this.$route.params;

            if(Object.keys(queryData).length > 0){
                categoryCd = queryData.categoryCd;
            }
            if(Object.keys(params).length > 0){
                categoryCd = params.categoryCd;
            }
            if(CATEGORY_CD == categoryCd) {
                if (_this.open) {
                    _this.open = false;
                } else {
                    if (_this.node[_this.children].length > 0) {
                        _this.open = true;
                    }
                }
            }

            if(CATEGORY_CD != categoryCd) {
                _this.$emit('selectNode', CATEGORY_CD);
            }
        },
        recursiveToOpen: function(node, categoryCd) {
            var _this = this;
            if(node[_this.value] == categoryCd) {
                if (node[_this.children].length > 0) {
                    _this.open = true;
                }
            } else if (node[_this.children]) {
                var child;
                for(var i = 0; i < node[_this.children].length; i++){
                    child = node[_this.children][i];
                    if(child[_this.value] == categoryCd) {
                        _this.open = true;
                    }
                    _this.recursiveToOpen(child, categoryCd);
                }
            }
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
         getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        reload: function() {
            window.location.reload();
        },
    }
}
</script>
<style scoped>
.img-mp {
    margin-right: 5px;
    margin-left: 5px;
}
.li-category{
    align-items: center;
    display: block !important;
}

.li-category > .lable {
    font-size: medium !important;
    height: 55px !important;
}
ul.tree-list, ul.tree-list ul {
    list-style: none;
     margin: 0;
     padding: 0;
   } 
   ul.tree-list ul {
     /*margin-left: var(--margin-left-ul);*/
     margin-left: 35px;
   }
   ul.tree-list li {
     margin: 0;
     color: #369;
     font-weight: bold;
   }
   ul.tree-list li:last-child {
       border-left:none;
   }
</style>